import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
    withAuthenticator,
    Button,
    Heading,
    Image,
    View,
    Text,
    TextField,
    Card,
    Flex,
  } from "@aws-amplify/ui-react";


  const NavBarView = styled(View)`
    background-color: rgba(239, 239, 240, 255);
    max-width:100%;
    padding:1rem;
  `

  const NiceLink = styled(Link)`
    color: rgba(0,0,0,255);
    text-decoration:none;
  `
  
  const MyFlex = styled(Flex)`
   div:last-of-type {
      margin-left: auto;
      margin-right:0px;
   }
  `

const Navbar=({ signOutButton } : { signOutButton : any})=>{
    return (    
        <NavBarView>
            <MyFlex
                direction="row"
                justifyContent="flex-start"
                wrap="nowrap"
                gap="1rem"
            >
            <div className='home'>
                <NiceLink to="https://www.aerenutrition.com">Home</NiceLink>
            </div>
            <div className='home'>
                <NiceLink to="/">Create Event</NiceLink>
            </div>
            <div className='myDetails'>
                <NiceLink to="/user">My Details</NiceLink>
            </div>
            <div>
            { signOutButton ? signOutButton : null}
            </div>
            { /*<div className='event-menu'>
                <NiceLink to="/event/menu">New Event</NiceLink>
            </div>
            <div className='event-new'>
                <NiceLink to="/event/new">Event Data (sample)</NiceLink>
            </div>
            <div className='event-new-calories'>
                <NiceLink to="/event/new/xxxxx/basket/calories">Calories (Sample)</NiceLink>
            </div>
            <div className='event-backet-checkout'>
                <NiceLink to="/event/new/xxxxx/basket/checkout">Checkout (Sample)</NiceLink>
    </div> */ }
            </MyFlex>
        </NavBarView>
    )

}

export default Navbar;